/* JoMuh R11: Kontaktformulare (Honeypot, Scroll-to-Message, Cookie-Einstellungen).
   ponytail: eigene Datei statt Append an jomuh-conversion.js. Der Code ist ein
   abgeschlossenes IIFE ohne gemeinsamen State mit der Conversion-Logik; eine
   zweite kleine Datei ist billiger und risikoaermer als ein Rewrite der 12-KB-Datei,
   in der Merkliste, Versand-Balken und Werktagslogik haengen. Geladen aus
   layout/theme.liquid direkt nach jomuh-conversion.js. */
(function () {
  // 1) Honeypot + Datenschutz-Pflichtcheckbox. Ein Listener fuer alle Formulare.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var hp = f.querySelector('.jomuh-hp input');
    if (hp && hp.value.trim() !== '') {
      e.preventDefault();
      // Bewusst keine Fehlermeldung: der Bot soll nicht lernen, woran es lag.
      if (window.console) console.warn('jomuh: Honeypot gefuellt, Absenden geblockt.');
      return;
    }
    // Newsletter-Datenschutz: Absenden nur mit Haken. Native required greift zuerst,
    // dieser Guard faengt Faelle ab, in denen die native Validierung umgangen wird.
    var privacy = f.querySelector('[data-jomuh-privacy]');
    if (privacy && !privacy.checked) {
      e.preventDefault();
      if (privacy.reportValidity) privacy.reportValidity();
    }
  }, true);

  // 2) Nach dem Redirect (?contact_posted=true) zur Meldung scrollen.
  //    Auf der PDP sitzt die Fragen-Box weit unten, ohne Sprung sieht sie niemand.
  //
  //    ZWEI FALLEN, beide im Preview gemessen (R13):
  //    a) behavior MUSS 'instant' sein. Das Theme setzt scroll-behavior: smooth
  //       auf <html>, also animiert JEDER programmatische Scroll - auch ohne
  //       explizites behavior. Eine laufende Smooth-Animation wird von den
  //       Layout-Shifts der nachladenden Bilder abgebrochen, die Seite blieb
  //       dann ganz oben stehen. Mit 'instant' springt sie hart und zuverlaessig.
  //       Der Offset unter dem Sticky-Header kommt aus scroll-margin-top (jomuh3.css).
  //    b) Erst bei 'load' scrollen, nicht schon bei defer-Ausfuehrung: vorher
  //       stehen die Bildhoehen nicht fest und das Ziel wandert.
  if (location.search.indexOf('contact_posted=') > -1) {
    var zurMeldung = function () {
      var msg = document.querySelector('[data-jomuh-fmsg], .contact-form__success, .contact-form__error');
      if (!msg) return;
      requestAnimationFrame(function () {
        msg.scrollIntoView({ block: 'center', behavior: 'instant' });
        msg.focus({ preventScroll: true });
      });
    };
    if (document.readyState === 'complete') zurMeldung();
    else window.addEventListener('load', zurMeldung);
  }

  // 3) Cookie-Einstellungen erneut oeffnen. Shopifys eigenes Banner
  //    (storefront-banner.js) stellt window.privacyBanner bereit.
  //    Jeder Link auf #cookie-einstellungen wird abgefangen, damit der Punkt
  //    ueber ein normales Shopify-Menue gepflegt werden kann.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#cookie-einstellungen"]');
    if (!a) return;
    e.preventDefault();
    if (window.privacyBanner && window.privacyBanner.showPreferences) {
      window.privacyBanner.showPreferences();
    } else {
      // ponytail: kein Banner aktiv -> Datenschutzerklaerung als Fallback,
      // damit der Link nie ins Leere klickt.
      location.href = '/policies/privacy-policy';
    }
  });

  // Selbstcheck: jomuhFormCheck() in der Konsole.
  window.jomuhFormCheck = function () {
    var hp = document.querySelector('.jomuh-hp input');
    if (!hp) return 'kein Formular auf dieser Seite';
    var box = hp.closest('.jomuh-hp');
    var unsichtbar = box.getBoundingClientRect().left < -1000;
    var bannerDa = !!(window.privacyBanner && window.privacyBanner.showPreferences);
    return 'Honeypot ' + (unsichtbar ? 'ok (unsichtbar)' : 'FEHLER (sichtbar!)') +
           ', privacyBanner ' + (bannerDa ? 'ok' : 'fehlt');
  };
})();
